import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocGlobalAlertListRoute: InvariantJiraRoute = {
	name: 'eoc-global-alerts',
	path: '/jira/ops/alerts',
	exact: true,
};
